import React from 'react'
import { useQuery } from 'react-query'
import { showEmployes } from '../../../MyApi/sb/employes'

import EmployesDetalis from '../../../Components/sb/employ/employShow/employDetalis'
import LoadingSpinner from '../../../Components/UI/spinner'

const EmployeProfile = () => {
    const user =JSON.parse(localStorage.getItem("user"))
    const id =user.id
    const {data , isLoading} = useQuery(["showEmploy",id ], ()=>showEmployes(id))
    const employes = data?.data
   if(isLoading){
    return <LoadingSpinner/>
   }
    if(!data){
        return <div>no data available</div>
    }
  return (
    <div>
        <EmployesDetalis employes={employes}/>
    </div>
  )
}

export default EmployeProfile